import { Button } from "@/lib/components/Button/Button";
import { quickAnimationCategories } from "./quick-animation-catalog";
import GradientTabButton from "@/lib/components/Button/GradientTabButton";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { IconImageGeneration } from "@tabler/icons-react";
import CreativeModeIntroHint from "./CreativeModeIntroHint";

type Props = {
  isVisible: boolean;
  currentCategoryId: string;
  creativeProjectExternalId: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onCategorySelect: (categoryId: string) => void;
};

export default function QuickAnimationsSidebar({
  isVisible,
  currentCategoryId,
  creativeProjectExternalId,
  isOpen,
  setIsOpen,
  onCategorySelect,
}: Props) {
  const openCreativeProjectSheet = useEditorStore(
    (state) => state.service.openCreativeProjectSheet,
  );

  if (!isVisible) {
    return null;
  }

  return (
    <div className="flex h-full shrink-0 grow-0 basis-63 flex-col overflow-hidden border-r border-grey-200">
      <div className="flex flex-1 flex-col gap-3 overflow-y-auto p-4">
        {quickAnimationCategories.map((category) => (
          <GradientTabButton
            key={category.id}
            icon={category.icon}
            label={category.label}
            isActive={currentCategoryId === category.id}
            onClick={() => onCategorySelect(category.id)}
          />
        ))}
      </div>
      <div className="shrink-0 grow-0 basis-auto p-4">
        <CreativeModeIntroHint isDialogOpen={isOpen}>
          {({ dismiss }) => (
            <Button
              variant="outline"
              size="sm"
              className="w-full"
              icon={<IconImageGeneration />}
              iconPosition="leading"
              onClick={() => {
                dismiss();
                setIsOpen(false);
                openCreativeProjectSheet(creativeProjectExternalId);
              }}
            >
              Creative Mode
            </Button>
          )}
        </CreativeModeIntroHint>
      </div>
    </div>
  );
}
